module.exports = __webpack_public_path__ + "img/appstore.804e8985.png";